<app-auth-modal-shell *ngIf="isVisible" title="Enter your account email" (closed)="closeModal()">
  <div class="verify-email-modal">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="verify-email-modal__form">
      <app-auth-email-field [control]="form.controls.email" [compactErrorSpacing]="true" />

      <div *ngIf="errorMessage" class="verify-email-modal__error">
        {{ errorMessage }}
      </div>
      <app-button variant="main" size="lg" [disabled]="form.invalid || isLoading" [fullWidth]="true">
        <span *ngIf="isLoading" class="app-spinner app-spinner--on-inverse"></span>
        <span *ngIf="!isLoading">Next</span>
      </app-button>
    </form>
    <div class="verify-email-modal__reset-password">
      <app-button variant="link" size="sm" (click)="openResetPassword()">Reset Password</app-button>
    </div>
  </div>
</app-auth-modal-shell>
